/**
 * What clicking a folder-resolved `{{chip}}` does, in one place for every host
 * (SyntaxHighlightInput, CodeEditor, VariableHighlighter, the Variables panel).
 *
 * - The folder that DEFINES the key is opened (the row carries its own
 *   `folderId` and `collectionId`), not the host's nearest folder.
 * - It opens that folder's PAGE on its Variables section (owner D2,
 *   28.09.2026 — the page replaced the Folder variables modal). Opening a page
 *   never loses a draft: every folder page keeps its draft in its own tab, and
 *   a pending autosave is flushed for the tab it was typed in (B1).
 * - A host may intercept through `variableContext.onOpenFolderVariables(target)`.
 * - Without a collection to open, nothing happens. A folder hit NEVER falls
 *   through to the inline popup: its writer has no folder scope and would put
 *   the edit into the environment, shadowed by the folder (review N4, D2).
 *
 * Returns true when the click was a folder hit (handled or deliberately inert).
 */
import { openFolderTab } from './folderTabs';

export function openFolderVariablesFor(hit, variableContext) {
  if (!hit || hit.type !== 'folder') return false;
  const collectionId = hit.collectionId ?? variableContext?.collectionId ?? null;
  if (!hit.folderId || collectionId == null) return true;
  const target = { collectionId: String(collectionId), folderId: String(hit.folderId) };
  if (typeof variableContext?.onOpenFolderVariables === 'function') {
    variableContext.onOpenFolderVariables(target);
  } else {
    openFolderTab(target.collectionId, target.folderId, { section: 'variables' });
  }
  return true;
}
